function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.916 10H7.083h5.833zm0 0l-1.25-1.25 1.25 1.25zm0 0l-1.25 1.25 1.25-1.25zm-5.833 0l1.25-1.25L7.083 10zm0 0l1.25 1.25L7.083 10zM15 14.167V5.833v8.334zm-10 0V5.833v8.334zm3.333 4.166h3.333c2.334 0 3.5 0 4.392-.454a4.166 4.166 0 001.821-1.82c.454-.892.454-2.059.454-4.392V8.333c0-2.333 0-3.5-.454-4.391a4.166 4.166 0 00-1.82-1.821c-.892-.454-2.059-.454-4.393-.454H8.333c-2.333 0-3.5 0-4.391.454A4.167 4.167 0 002.12 3.94c-.454.892-.454 2.059-.454 4.392v3.334c0 2.333 0 3.5.454 4.391a4.166 4.166 0 001.82 1.821c.892.454 2.059.454 4.392.454z",
  fill: "#fff"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M12.916 10H7.083m5.833 0l-1.25-1.25m1.25 1.25l-1.25 1.25M7.083 10l1.25-1.25M7.083 10l1.25 1.25M15 14.167V5.833M5 14.167V5.833m3.333 12.5h3.333c2.334 0 3.5 0 4.392-.454a4.166 4.166 0 001.821-1.82c.454-.892.454-2.059.454-4.392V8.333c0-2.333 0-3.5-.454-4.391a4.166 4.166 0 00-1.82-1.821c-.892-.454-2.059-.454-4.393-.454H8.333c-2.333 0-3.5 0-4.391.454A4.167 4.167 0 002.12 3.94c-.454.892-.454 2.059-.454 4.392v3.334c0 2.333 0 3.5.454 4.391a4.166 4.166 0 001.82 1.821c.892.454 2.059.454 4.392.454z",
  stroke: "#666A72",
  strokeWidth: 1.25,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgDragNew = function SvgDragNew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _ref, _ref2);
};

export default SvgDragNew;